var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-semibold text-sm cursor-pointer",class:[
    _vm.sizeClass,
    _vm.selected
      ? 'text-white bg-blue-900 hover:text-white hover:bg-blue-800'
      : (_vm.bgClass + " " + _vm.textClass + " hover:" + _vm.textClass + " hover:" + _vm.bgHoverClass),
    _vm.tight ? 'p-1' : 'px-4 py-2 m-1',
    _vm.unrounded ? '' : 'rounded',
    _vm.rotateText ? 'relative inline-block' : ''
  ],on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('div',{class:_vm.rotateText
        ? 'whitespace-no-wrap absolute transform -rotate-90 -translate-x-1/2 -translate-y-1/2'
        : '',style:({
      top: _vm.rotateText ? '50%' : 'auto',
      left: _vm.rotateText ? '50%' : 'auto'
    })},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }